import { create } from 'zustand';
import { getAppDownloadConfig, getAppPkgUrl } from '@/api/common';

type AppDownloadConfig = { [key: string]: any } | null;
type State = {
  appDownloadConfig: AppDownloadConfig;
  appPkgUrl: null | string;
  setAppDownloadConfig: (data: AppDownloadConfig) => void;
  getAppDownloadConfig: () => Promise<AppDownloadConfig>;
  getAppPkgUrl: (params: any) => Promise<AppDownloadConfig>;
};
export const useAppDownloadConfigStore = create<State>((set, get) => ({
  appDownloadConfig: null,
  appPkgUrl: '',
  setAppDownloadConfig: (data) => set({ appDownloadConfig: data }),
  getAppDownloadConfig: async () => {
    const appDownloadConfig = get().appDownloadConfig;
    if (appDownloadConfig) return appDownloadConfig;
    const res = await getAppDownloadConfig();
    set({ appDownloadConfig: res.data.app_download});
    return res;
  },
  getAppPkgUrl: async (params) => {
    const res = await getAppPkgUrl(params);
    set({ appPkgUrl: res.data.app_download_url });
    return res;
  },
}));
